import FormProvider from "@providers/FormProvider";
import { Form, useFormik } from "formik";
import DatePicker from "@components/Formik/DatePicker";
import Select from "@components/Formik/Select";
import Button from "@components/Button";
import People from "./People";
import Link from "@components/Link";
import styles from "./SearchControl.module.scss";
import { useTranslationContext } from "@providers/TranslationProvider";
import cx from "classnames";
import { useRouteContext } from "@providers/RouteProvider";
import helper from "@utils/helper";
import gstyles from "@gstyles/index";
import { formatPayload } from "@utils/dateFormatter";
import _ from "lodash";
import { HOTEL_CODES } from "@utils/constant";
import { usePageContext } from "@providers/PageProvider";
const View = ({ type = "responsive" }: any) => {
  const { i18n } = useTranslationContext();
  const { router } = useRouteContext();
  const { hotel } = usePageContext();
  const form = useFormik({
    enableReinitialize: true,
    initialValues: {
      hotel_code: HOTEL_CODES[hotel] ?? "", // hotel 65: "70AS04",
      check_in: null,
      check_out: null,
      num_of_rooms: 1,
      num_of_adults: 2,
      num_of_children: 0,
    },
    onSubmit: async (values) => {
      const payload = {
        ...values,
        check_in: formatPayload(_.get(values, "check_in") || ""),
        check_out: formatPayload(_.get(values, "check_out") || ""),
      };
      const url = helper.getBookingLink(payload);
      router.open(url);
    },
  });
  return (
    <FormProvider form={form}>
      <Form>
        <div className={styles.box}>
          <div
            className={cx(
              styles.searchBox,
              {
                "xs:block sm:hidden": type === "booking",
              },
              styles[type]
            )}
          >
            <div className={styles.item}>
              <Select
                prefix={
                  <div
                    style={{ paddingLeft: "1rem" }}
                    className="flex items-center"
                  >
                    {gstyles.icons({
                      name: "bed-queen",
                      size: 24,
                      alt: "bed queen",
                    })}
                    <div className={cx(styles.iconText)}>
                      {i18n.t("SearchControl.room")}
                    </div>
                  </div>
                }
                className={styles.select}
                boxOptionProps={{ className: styles.boxOption }}
                optionProps={{ className: styles.option }}
                inputProps={{ className: styles.input }}
                // theme="dark"
                // placeholder={i18n.t("Form.placeholderRoomType")}
                type="placeholderNoneAmin"
                name={"num_of_rooms"}
                options={[
                  {
                    label: 1,
                    key: 1,
                    value: 1,
                  },
                  {
                    label: 2,
                    key: 2,
                    value: 2,
                  },
                  {
                    label: 3,
                    key: 3,
                    value: 3,
                  },
                ]}
              />

              {/* <Select
                className={styles.select}
                boxOptionProps={{ className: styles.boxOption }}
                optionProps={{ className: styles.option }}
                inputProps={{ className: styles.input }}
                // theme="dark"
                placeholder={i18n.t("Form.placeholderRoomType")}
                type="placeholderNoneAmin"
                name={"select"}
                options={[
                  {
                    label: i18n.t("Rooms.Signature"),
                    key: "signature",
                    value: "signature",
                  },
                  {
                    label: i18n.t("Rooms.Executive"),
                    key: "executive",
                    value: "executive",
                  },
                  {
                    label: i18n.t("Rooms.FamilySuite"),
                    key: "family_suite",
                    value: "family_suite",
                  },
                ]}
              /> */}
            </div>
            <div className={styles.border}></div>
            <div className={styles.date}>
              <div className={styles.item}>
                <DatePicker
                  name={"check_in"}
                  placeholder={i18n.t("Form.placeholderArrivalDate")}
                />
              </div>
              <div className={styles.border}></div>
              <div className={styles.item}>
                <DatePicker
                  name={"check_out"}
                  placeholder={i18n.t("Form.placeholderDepartureDate")}
                />
              </div>
            </div>
            <div className={styles.border}></div>
            <div className={styles.dropdown}>
              <People />
            </div>
            <Button
              type="primary"
              onClick={form.handleSubmit}
              className={cx(styles.button, "uppercase")}
              label={i18n.t("SearchControl.checkAvailability")}
            />
          </div>
          <div
            className={cx(styles.btnBookNow, {
              "xs:block sm:hidden": type === "booking",
              ["hidden"]: type === "responsive",
            })}
          >
            <Button
              textWhite
              onClick={form.handleSubmit}
              type="primary"
              className={styles.button}
              label={i18n.t("Button.bookNow")}
            />
          </div>
          <Link
            className={styles.link}
            href={router.toUrl("privacy", {
              legalNoticeType: "BestRateGuaranteed",
            })}
            label={i18n.t("SearchControl.bestPrice")}
          />
        </div>
      </Form>
    </FormProvider>
  );
};
export default View;
